import { apiInitState, reducerApiConstructor } from "../helpers";

export const searchInitState = {
  data: null,
  query: "",
  queryGroup: "",
  groupPage: 0,
  filteredData: [],
  init: false,
  profileInfo: {
    info: null,
    attachments: [],
  },
  api: apiInitState,
};

export const searchReducers = {
  getSearcherInfo: () => {},

  setSearcherInfo: (state, { payload }) => {
    state.data = payload.data;
    state.init = true;
  },

  setQueryString: (state, { payload }) => {
    state.query = payload;
  },

  queryChanged: (state, { payload }) => {
    state.pending = payload;
  },

  setFilteredData: (state, { payload }) => {
    state.pending = false;
    state.filteredData = payload;
  },

  getProfileInfo: () => {},

  setProfileInfo: (state, { payload }) => {
    state.profileInfo.attachments = payload.attachments;
    state.profileInfo.info = payload.info;
    state.init = true;
  },

  clearProfileInfo: (state, action) => {
    state.profileInfo = {
      info: null,
      attachments: [],
    };
  },

  setGroupQueryString: (state, { payload }) => {
    state.queryGroup = payload;
  },

  ...reducerApiConstructor(),
};
